import Link from 'next/link';

type PreviewAlertProps = {
  preview?: boolean;
};

const PreviewAlert: React.FC<PreviewAlertProps> = ({ preview }) => {
  if (!preview) return null;

  return (
    <div className=' sticky top-0 z-50 bg-gradient-to-r from-primary-dark to-primary-extra-dark text-white shadow-md'>
      <div className='layout py-2 text-center text-sm'>
        This page is a preview.
        <Link
          href='/api/exit-preview'
          className='hover:text-cyan mx-1 underline transition-colors duration-200'
        >
          Click here
        </Link>
        to exit preview mode.
      </div>
    </div>
  );
};

export default PreviewAlert;
